<template>
    <div point question :id="`question-${questionData.number}`" @keyup.enter="submitQuestion">
        <questionheader :questionData="questionData" />
        <div data-question-main>
            <div data-total aria-live="assertive">
                <p
                    data-remaining
                >{{remainingPoints}} <span>{{$store.getters.textResource(`rs_remaining`)}}</span></p>
            </div>
            <div
                v-for="(answer, index) in questionData.answers"
                :key="`answer-${index}`"
                data-answer
            >
                <div data-answer-container>
                    <questioninput
                        :answerData="answer"
                        :questionData="questionData"
                        :disabled="!get.editingAllowed(questionData)"
                        @element-receives-input="changeTextValue(index)"
                    />
                    <div class="range-slider">
                        <input type="range"
                            v-model="sliderAnswers[index].openField"
                            min="0" 
                            class="range"
                            :max="restrictions.requiredPoints" 
                            @input="changeSliderValue(index)"
                        >
                    </div>
                    <answerdescription
                        v-if="answer.description !== `` "
                        :answerData="answer"
                        :questionData="questionData"
                    />
                </div>
            </div>
        </div>
        <questionfooter :questionData="questionData" />
        <!-- The component that gives the user hints on how the validation goes -->
        <validationpopup :questionValidation="questionValidation" :customValidation="customValidation" />
    </div>
</template>

<script>
import mixins from "@/global/mixins";

export default {
    name: `pointdistribution-question`,
    mixins: [mixins.defaultQuestion],
    data() {
		return {
            sliderAnswers: [],
            remainingPoints: 0
        }
    },
    computed: {
        answersGiven() {
            return this.questionData.answers.filter((answer) => answer.openField !== ``).length;
        },
  
        customValidation(){
            return [{ isValid: this.remainingPointsIsZero(this.remainingPoints), validationType: `requiredPoints`, value: this.restrictions.requiredPoints }];
        },
    },
    methods: {
        remainingPointsIsZero() {
            let numStr = this.remainingPoints.toString();

            let parts = numStr.split('.');

            return parts[0] === '0' && (!parts[1] || parts[1].split('').every(digit => digit === '0'));
        },
        calculatePercentage(answer) {
            let openField = parseInt(answer.openField);

            let decimals = this.questionData.answers[0].validation["numberScale"];
            const min = 0;
            const max = this.restrictions.requiredPoints;

            const val = parseFloat(openField);

            if(decimals != -1){
                val.toFixed(decimals);
            }            
            let percentage = (val - min) * 100 / (max - min)

            return percentage;
        },
        changeTextValue(index) {
            if(this.questionData.answers[index].openField.endsWith(`.`) 
            || this.questionData.answers[index].openField.endsWith(`,`)) return;

            let value = this.questionData.answers[index].openField.replace(/,/, ".");
            // Ensure the value is within range (0 and requiredAmount)
            if (value < 0) {
                value = 0;
            } else if (value > this.restrictions.requiredPoints) {
                value = this.restrictions.requiredPoints;
            }
             
            // Update the input text and slider
            this.questionData.answers[index].openField = value;
            this.sliderAnswers[index].openField = value;

            this.changeSliderValue(index);
        },
        changeSliderValue(index){
            let emptyIfZero = false;
            if(this.sliderAnswers[index].openField === ``) {
                this.sliderAnswers[index].openField = `0`;
                emptyIfZero = true;
            }    
            
            this.countCurrentTotal(index);

            this.sliderAnswers.forEach((slider, sliderIndex) => {
                document.getElementsByClassName('range')[sliderIndex].value = slider.openField;
            }); 

            if(emptyIfZero) {
                this.questionData.answers[index].openField = ``;    
            }
            else {
                // Update the text input to match the slider.
                this.questionData.answers[index].openField = this.sliderAnswers[index].openField.toString();          
            }              
        },
        countCurrentTotal(index) {
            let decimals = this.questionData.answers[0].validation["numberScale"];
            let totalSum = this.restrictions.requiredPoints;
            let usedTotal = this.sliderAnswers.reduce((sum, slider) => sum + parseFloat(slider.openField), 0);       
            let remaining = totalSum - usedTotal;

            if (remaining < 0) {
                this.sliderAnswers[index].openField = parseInt(this.sliderAnswers[index].openField) + remaining;

                // /// Don't let the remaining show more than the decimals set.
                let copyAnswer = this.sliderAnswers[index].openField.toString();
                let indexOfDot = copyAnswer.indexOf(`.`);
                if (indexOfDot !== -1 && remaining.toString().indexOf(`-`) === 0 && decimals != -1) {
                    this.sliderAnswers[index].openField = this.sliderAnswers[index].openField.toFixed(decimals); 
                }

                usedTotal = totalSum;
            }

            if(decimals != -1){
                this.remainingPoints = (totalSum - usedTotal).toFixed(decimals);
            } 
            else {
                this.remainingPoints = (totalSum - usedTotal)
            }    
        },
    },
    created: function () {
        let changedAnswers = structuredClone(this.questionData.answers); // eslint-disable-line
        this.remainingPoints = this.restrictions.requiredPoints;
        changedAnswers.map(function(answer) { 
            if(answer.openField === `` ){
                answer.openField = 0;
            }          
            return answer;   
        });
        this.sliderAnswers = changedAnswers;
        this.countCurrentTotal();
    },

};
</script>

<style>[point] {
    [data-answer] {
        align-items: flex-start;
        flex-direction: column;
        padding: 30px 0;
        border-bottom: 1px solid #D9D9D9;
        margin: 0;
        &:last-of-type {
            border: none;
        }
    }
    [data-questioninput] {
        flex-direction: row;
        [data-input] {
            margin: 0;
            order: 1;
        }

        [data-validation-message] {
            margin: 0;
            order: 0;
        }
    }
    [data-answer-container] {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    [data-input-container] {
        width: 100px;
        position: relative;
        height: 48px;
    }
    [data-total] {
        display: flex;
        justify-content: flex-end;
        padding-left: 5px;
        border-bottom: 1px solid #d9d9d9;

        [data-text-total] {
            display: block;
        }
        [data-remaining] {
            color: var(--primary-color);
        }
    }
    input[type="range"] {
        appearance: none;
        -webkit-appearance: none;
        margin-right: 15px;
        width: 100%;
        height: 7px;
        background: #d9d9d9;
        border-radius: 5px;
        background-image: linear-gradient(var(--primary-color), var(--primary-color));
        background-repeat: no-repeat;
    }
    input[type="range"]:focus {
        outline: none;
    }
    /* Input Thumb */
    input[type="range"]::-webkit-slider-thumb {
        appearance: none;
        -webkit-appearance: none;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        background: var(--primary-color);
        cursor: ew-resize;
        box-shadow: 0 0 2px 0 #555;
        transition: background .3s ease-in-out;
    }

    input[type="range"]::-moz-range-thumb {
        appearance: none;
        -webkit-appearance: none;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        background: var(--primary-color);
        cursor: ew-resize;
        box-shadow: 0 0 2px 0 #555;
        transition: background .3s ease-in-out;
    }

    input[type="range"]::-ms-thumb {
        appearance: none;
        -webkit-appearance: none;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        background: #ff4500;
        cursor: ew-resize;
        box-shadow: 0 0 2px 0 #555;
        transition: background .3s ease-in-out;
    }

    input[type="range"]::-webkit-slider-thumb:hover {
        background: var(--primary-color);
    }

    input[type="range"]::-moz-range-thumb:hover {
        background: var(--primary-color);
    }

    input[type="range"]::-ms-thumb:hover {
        background: var(--primary-color);
    }

    /* Input Track */
    input[type=range]::-webkit-slider-runnable-track  {
        appearance: none;
        -webkit-appearance: none;
        box-shadow: none;
        border: none;
        background: transparent;
    }

    input[type=range]::-moz-range-track {
        appearance: none;
        -webkit-appearance: none;
        box-shadow: none;
        border: none;
        background: transparent;
    }

    input[type="range"]::-ms-track {
        appearance: none;
        -webkit-appearance: none;
        box-shadow: none;
        border: none;
        background: transparent;
    }
}

</style>